import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { FormGroup } from "@angular/forms";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { DragulaService } from 'ng2-dragula';
import { DragContainerComponent } from '@medsurf/flat-components';

@Component({
    selector: 'medsurf-quiz-base-question',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: ``,
    styles: [],
    standalone: false
})
export abstract class BaseQuestionComponent<TQuestion extends FlatModels.QuestionEntityModels.Question> extends DragContainerComponent {
  @Input({required: true}) set index(value: number) {
    this.#index = value;
    this.updateForm();
  }
  get index() {
    return this.#index;
  }
  @Input({required: true}) set question(value: TQuestion) {
    this.#question = structuredClone(value);
    this.updateForm();
  }
  get question() {
    return this.#question;
  }
  
  protected isSubmitted = signal(false);
  #index: number;
  #question: TQuestion;
  form: FormGroup;
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public trainingSharedFacade: FlatFacades.TrainingSharedFacade,
              dragulaService: DragulaService) {
    super(dragulaService);
  }

  abstract updateForm(): void;
  abstract onSubmit(): void;

}
